var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { DialogContent } from "@material-ui/core";
import MuiDialog from "@material-ui/core/Dialog";
import { DialogActions } from "../dialog-actions";
import { DialogTitle } from "../dialog-title";
import { getCosmosDataProps } from "../utils/comsosCompat";
import { useId } from "../utils/use-id";
export var Dialog = React.forwardRef(function (props, ref) {
    var title = props.title, actions = props.actions, children = props.children, onClose = props.onClose, idProp = props.id, _a = props.disableContentWrap, disableContentWrap = _a === void 0 ? false : _a, dialogProps = __rest(props, ["title", "actions", "children", "onClose", "id", "disableContentWrap"]);
    var id = useId(props.id);
    var titleId = !!title && !!id ? id + "-title" : undefined;
    return (React.createElement(MuiDialog, __assign({ PaperProps: { elevation: 4 } }, dialogProps, { id: id, ref: ref, onClose: onClose, "aria-labelledby": titleId }, getCosmosDataProps("dialog")),
        !!title && (React.createElement(DialogTitle, { id: titleId, onClose: onClose }, title)),
        disableContentWrap ? children : React.createElement(DialogContent, __assign({}, getCosmosDataProps("dialog.body")), children),
        !!actions && React.createElement(DialogActions, __assign({}, getCosmosDataProps("dialog.footer")), actions)));
});
